import {Accordion, Col, Row, Spinner, Tab, Tabs} from "react-bootstrap";
import {useCollection} from "react-firebase-hooks/firestore";
import {collection, query, where} from "firebase/firestore";
import {appFirestore} from "../../../index";
import {useAppSelector} from "../../hooks";
import {selectCurrentUser} from "../../../features/AppStateSlice";
import {useEffect, useMemo, useState} from "react";
import {employeesStatisticsDataConverter} from "../../../firebase/FirebaseEmployeeStatisticsLoader";
import {RREmployeesStatisticsType} from "../../types/RREmployeeStatisticType";
import {ARRAY_MONTHS_FULL, minutesToHoursAsString} from "../../tools";

const MEmployeeStatistics = () => {
    const currentUser = useAppSelector(selectCurrentUser);
    const employeeId = currentUser?.employeeId;
    // const employeeId = "e4Q41OWO2Z1DWxHcHp2g";

    const statisticsQuery = useMemo(
        () => (employeeId
            ? query(collection(appFirestore, 'employeesStatistics'), where("employeeId", "==", employeeId))
            : null),
        [employeeId]
    );
    const [data, loading, error] = useCollection(statisticsQuery);

    const [statistics, setStatistics] = useState<RREmployeesStatisticsType>([]);
    const [statisticsYears, setStatisticsYears] = useState<string[]>([]);

    const [selectedYear, setSelectedYear] = useState<string>("");

    useEffect(() => {
        if (data) {
            const years = new Set<string>();
            const newStatistics = employeesStatisticsDataConverter(data.docs);
            newStatistics.sort((a, b) => {
                const aYear = parseInt(a.monthYear.substring(a.monthYear.length - 4));
                const bYear = parseInt(b.monthYear.substring(b.monthYear.length - 4));
                const aMonth = parseInt(a.monthYear.substring(0, a.monthYear.length - 4));
                const bMonth = parseInt(b.monthYear.substring(0, b.monthYear.length - 4));

                years.add(aYear.toString());
                years.add(bYear.toString());

                if (aYear === bYear) {
                    return bMonth - aMonth;
                } else {
                    return bYear - aYear;
                }
            });
            setStatistics(newStatistics);
            const sortedYears = Array.from(years).sort((a, b) => parseInt(b) - parseInt(a));
            setStatisticsYears(sortedYears);
            setSelectedYear(sortedYears[0]);
        } else {
            setStatistics([]);
            setStatisticsYears([]);
        }
    }, [data]);

    return (<>
        <Row className={"mt-3 mb-3 text-center"}>
            <Col><b>ЗАРАБОТЕНИ ЧАСОВЕ</b></Col>
        </Row>
        <Row className={"mt-3 mb-3 text-center"}>
            <Col>
                {
                    statisticsYears.length > 0 ?
                        <Accordion className={"fs-5 fw-bold"}>
                            {
                                statisticsYears.map(
                                    (y, idx) => {
                                        return <Accordion.Item key={idx} eventKey={idx.toString()}>
                                            <Accordion.Header><span className={"fs-4 fw-bold"}>{y}</span></Accordion.Header>
                                            <Accordion.Body className={"bg-secondary-light"}>
                                                {
                                                    statistics.filter(s => s.monthYear.includes(y)).map(
                                                        (s, idx) => {
                                                            const month = parseInt(s.monthYear.substring(0, s.monthYear.length - 4));
                                                            return <Row key={idx} className={"m-3"}>
                                                                <Col>{ARRAY_MONTHS_FULL[month]}</Col>
                                                                <Col className={"text-primary"}>{minutesToHoursAsString(s.workHours)}</Col>
                                                            </Row>
                                                        }
                                                    )
                                                }
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    }
                                )
                            }
                        </Accordion>
                    : (
                        loading ? <Spinner animation={"border"}/> : (
                            error ? <span className={"text-danger"}>Възникна грешка!</span> : "Няма данни"
                        ))
                }
            </Col>
        </Row>
    </>);
}

export default MEmployeeStatistics;
